import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { AgentNote } from '.';
import { Button } from '@progress/kendo-react-buttons';
import { trackChangesIcon, pencilIcon, xIcon } from '@progress/kendo-svg-icons';

export default function MyCommandCell(
  enterEdit: (dataItem: AgentNote) => void,
  remove: (dataItem: AgentNote) => void,
  save: (dataItem: AgentNote) => void,
  cancel: (dataItem: AgentNote) => void,
  logs: (dataItem: AgentNote) => void,
  editField: string
) {
    return class extends React.Component<GridCustomCellProps> {
        render() {
            return !this.props.dataItem[editField]
                ? (
                    <td {...this.props.tdProps} className={[this.props.tdProps?.className, "k-command-cell"].filter(Boolean).join(" ")}>
                        <Button
                            themeColor="primary"
                            title="Edit"
                            className="k-grid-edit-command"
                            svgIcon={pencilIcon}
                            onClick={(e) => enterEdit(this.props.dataItem)}
                        />
                        {this.props.dataItem.Active && <Button
                            themeColor='error'
                            title="Delete"
                            className="k-grid-remove-command"
                            svgIcon={xIcon}
                            onClick={(e) => window.confirm('Confirm deleting: ' + this.props.dataItem.Domain) && remove(this.props.dataItem)}
                        />}
                        <Button
                            title="View audit logs"
                            svgIcon={trackChangesIcon}
                            onClick={(e) => logs(this.props.dataItem)}
                        />
                    </td>
                )
                : (
                    <td {...this.props.tdProps} className={[this.props.tdProps?.className, "k-command-cell"].filter(Boolean).join(" ")}>
                        <Button
                            themeColor="primary"
                            className="k-grid-save-command"
                            onClick={(e) => save(this.props.dataItem)}
                        >
                            {this.props.dataItem.ID
                                ? 'Update'
                                : 'Add'}
                        </Button>
                        <Button
                            className="k-grid-cancel-command"
                            onClick={(e) => cancel(this.props.dataItem)}>{this.props.dataItem.ID
                                ? 'Cancel'
                                : 'Discard'}
                        </Button>
                    </td>
                );
        }
    }
};
